import { render, staticRenderFns } from "./LampArea.vue?vue&type=template&id=3a62665c&scoped=true&"
var script = {}
import style0 from "./LampArea.vue?vue&type=style&index=0&id=3a62665c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a62665c",
  null
  
)

export default component.exports